import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import CricketMatchesList from "./pages/Sports/Cricket";
import TennisMatchesList from "./pages/Sports/Tennis";
import SoccerMatchesList from "./pages/Sports/Soccer";
import Inplay from "./pages/Inplay";
import BasketballMatchesList from "./pages/Sports/Basketball";
import QuickLinks from "./pages/QuickLinks";
import CTSfullMarket from "./pages/FullMarket/CTSfullMarket";
import LayoutFullPage from "./components/LayoutFullPage";
import Account from "./pages/Account";
import MultiMarkets from "./pages/Account/MultiMarkets";
import Profile from "./pages/Account/Profile";
import SportsTv from "../CommonComponents/SportsTv";
import Horse from "./pages/Sports/Horse";
import HorseMarket from "./pages/Sports/Horse/HorseMarket";
import GameLobby from "./pages/Sports/InternationalCasino/GameLobby";
import MyProfile from "./pages/Account/Profile";
import RollingCommission from "./pages/Account/rolling-commission";
import AccountStatement from "./pages/Account/account-statement";
import BetHistory from "./pages/Account/BetHistory";
import ProfitLoss from "./pages/Account/ProfitLoss";
import PasswordChangeHistory from "./pages/Account/PasswordChangeHistory";
import ActiveLogs from "./pages/Account/ActiveLogs";
import ProtectedRoute from "../CommonComponents/ProtectedRoute";
import SignUp from "./pages/SignUp/SignUp";
import { IsSignUpButton } from "../AsianExchangeSrc/utils/helper/commonSelectors";
import { useSelector } from "react-redux";
import SettingsPage from "./pages/Settings/Settings";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw/Withdraw";

export const AuraExchangeRoutes = () => {

  const SignUpButton = useSelector(IsSignUpButton())
  return createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/cricket" />,
  },
  {
    path: "/login",
    element: <Login />,
    },

  {
    path: "/signup",
    element: <SignUp />,
  }
,

  {
    path: "/",
    element: <Home />,
    children: [
      {
        path: "cricket",
        element: <CricketMatchesList />,
      },
      {
        path: "tennis",
        element: <TennisMatchesList />,
      },
      {
        path: "soccer",
        element: <SoccerMatchesList />,
      },
      {
        path: "horseRacing",
        element: <Horse />,
      },
      {
        path: "greyhoundRacing",
        element: <BasketballMatchesList />,
      },
      {
        path: "basketball",
        element: <BasketballMatchesList />,
      },
      {
        path: "lottery",
        element: <BasketballMatchesList />,
      },
      {
        path: "sports",
        element: <QuickLinks />,
      },
      {
        path: "live-casino",
        element: <div> Live Casino </div>,
      },
      {
        path: "inplay",
        element: <Inplay />,
      },
    ],
  },
  {
    path: "/",
    element: <LayoutFullPage />,
    children: [
      {
        path: "full-market",
        element: <CTSfullMarket />,
      },
      // {
      //   path: "horse-market",
      //   element: <HorseMarket />,
      // },
      {
        path: "account",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Account />
          </ProtectedRoute>
        ),
      },
      {
        path: "myprofile",
        element: (
          <ProtectedRoute>
            <MyProfile />
          </ProtectedRoute>
        ),
      },
      {
        path: "multimarket",
        element: (
          <ProtectedRoute>
            <MultiMarkets />
          </ProtectedRoute>
        ),
      },
      {
        path: "rolling-commission",
        element: (
          <ProtectedRoute>
            <RollingCommission />
          </ProtectedRoute>
        ),
      },
      {
        path: "account-statement",
        element: (
          <ProtectedRoute>
            <AccountStatement />
          </ProtectedRoute>
        ),
      },
      {
        path: "bets-history",
        element: (
          <ProtectedRoute>
            <BetHistory />
          </ProtectedRoute>
        ),
      },
      {
        path: "profit-loss",
        element: (
          <ProtectedRoute>
            <ProfitLoss />
          </ProtectedRoute>
        ),
      },
      {
        path: "password-history",
        element: (
          <ProtectedRoute>
            <PasswordChangeHistory />
          </ProtectedRoute>
        ),
      },
      {
        path: "activity-log",
        element: (
          <ProtectedRoute>
            <ActiveLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "settings",
        element: (
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "deposit",
        element: (
          <ProtectedRoute>
            <Deposit />
          </ProtectedRoute>
        ),
      },
      {
        path: "withdraw",
        element: (
          <ProtectedRoute>
            <Withdraw />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "game-lobby",
    element: <GameLobby />,
  },
  {
    path: "tv",
    element: <SportsTv />,
  },
]);
}
